
import { useEffect } from "react";

const WIDGET_URL =
  "https://salesiq.zohopublic.com/widget?wc=siqfe49cfd6a1f7688f5e5e4711d7869d26cd9fe865a32ee44dd9bb611269fbc493";

export default function ZohoSalesIQ() {
  useEffect(() => {
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      ready: function () {},
    };

    if (document.getElementById("zsiqscript")) return;

    const script = document.createElement("script");
    script.id = "zsiqscript";
    script.src = WIDGET_URL;
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  return null;
}
